/**
* shortcodes
*
* example incoming html:
* <p>my content</p>
*
* <p>#### foo ####</p>
* <p>foo content</p>
* <p>#### end ####</p>
*
* <!-- any stray tags (like <p>) on the same -->
* <!-- line as four pound signs are ignored: -->
*
* ####another_section
* <p>another_section content</p>
* #### end
*
* example output:
* [
*   { type: 'content', content: '<p>my content</p>' },
*   { type: 'section', name: "foo", contents: [
*       { type: 'content', content: '<p>foo content</p>' }
*   ] },
*   { type: 'section', name: "another_section", contents: [
*       { type: 'content', content: '<p>another_section content</p>' }
*   ] },
* ]
*
* the output would then be parsed and shortcode sections
* can be transformed, deleted, or whatever.
* then after transformation, the list elements can
* just be concatenated
*/

const marker = '####'

// match marker with surrounding tags (like <p>) and linebreaks
const markerRegex = new RegExp('(\n.*' + marker + '.*\r?\n)', 'g')

// match inside matched surrounding marker for marker with name
const innerMarkerRegex = new RegExp('(' + marker + '[^<\r?\n]*)', 'g')

/**
* parse string for raw element list
* @param  {string} str, can have html and shortcode sections
* @return {array}  array of { type, ?content }
*/
function parse (str) {
  if (!str) {
    return []
  }

  return str
  .split(markerRegex)
  .map(original => {
    if (original.includes(marker)) {
      const name = original
        .split(innerMarkerRegex)
        .filter(part => part.includes(marker))[0]
        .replace(marker, '')
        .toLowerCase()
        .trim()

      if (!name) {
        // error
        return null
      }

      const type = name === 'end'
      ? 'end'
      : 'marker'

      return { type, name, original }
    } else {
      return { type: 'content', content: original }
    }
  })
  .filter(v => v !== null)
}

/**
* takes a parsed element list and make sections out of
* input subsequences of types = [marker, ?content, end]
*/
function sectionizeRaw (els) {
  const len = els.length

  const sections = []

  let section = null

  for (let i = 0; i < len; i++) {
    const current = els[i]

    if (current.type === 'marker') {
      if (section) {
        // well, they forgot an end tag
        // but we will forgive them
        // and include the previous section
        sections.push(section)
        section = null
      }

      section = {
        type: 'section',
        name: current.name,
        contents: []
      }
    } else if (current.type === 'end') {
      if (section) {
        sections.push(section)
        section = null
      }
    } else if (current.type === 'content') {
      if (section) {
        section.contents.push(current)
      } else {
        sections.push(current)
      }
    }
  }

  if (section) {
    // well, they forgot an end tag
    // but we will forgive them
    // and include the previous section
    sections.push(section)
    section = null
  }

  return sections
}

/**
* Public default function
*/
export default function sections (str) {
  return sectionizeRaw(parse(str))
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/shortcodes.js